module.exports = __webpack_public_path__ + "images/72fccacc7a0b58f8e069bc88368d8d56.png";